// extracted by mini-css-extract-plugin
export default {"clearSelectionButton":"clear-selection-button-module__clearSelectionButton--cEG7Z","selectedItemCount":"clear-selection-button-module__selectedItemCount--jPsoj"};